import React         from 'react';
import PreloaderIcon from '../../icons/PreloaderIcon';

export default function Preloader() {
  React.useEffect(() => {
    document.body.classList.add('fixed');

    return () => document.body.classList.remove('fixed');
  }, []);

  return (
    <div id={'preloader'}>
      <PreloaderIcon />
    </div>
  );
}